import { Typography } from "components/parts/Typography/Typography";
import React from "react";
import { Monitor, NotificationEvent } from "types/graphqlapi";
import { useMailList } from "pages/MailHistoryManagement/MailDetail/hook";
import {
  StyledMailContent,
  StyledMailDetailCard,
  StyledMailError,
  StyledMailHeader,
  StyledMailHeaderWrapper,
  StyledMailMessage,
  StyledMailToContainer,
} from "pages/MailHistoryManagement/MailDetail/styled";

type InterviewDetailProps = {
  selectedNotificationEvent: NotificationEvent | undefined;
  monitorList: Monitor[];
};

export const MailDetail: React.FC<InterviewDetailProps> = ({
  selectedNotificationEvent,
  monitorList,
}) => {
  const { mailList, setMailList, fetchMailList } = useMailList();

  const filteredMonitorList = monitorList.filter((monitor) =>
    mailList.map((mail) => mail.monitor_id).includes(monitor.id)
  );

  const sortedMailList = mailList.sort((a, b) => {
    const indexA = filteredMonitorList.findIndex(
      (monitor) => monitor.id === a.monitor_id
    );
    const indexB = filteredMonitorList.findIndex(
      (monitor) => monitor.id === b.monitor_id
    );

    return indexA - indexB;
  });

  const fetchMailData = async (
    selectedNotificationEvent: NotificationEvent
  ) => {
    const data = await fetchMailList(selectedNotificationEvent);
    if (data === undefined) return;
    setMailList(data);
  };

  React.useEffect(() => {
    if (selectedNotificationEvent !== undefined) {
      fetchMailData(selectedNotificationEvent);
    }
  }, [selectedNotificationEvent]);

  return (
    <StyledMailDetailCard>
      {sortedMailList.length && monitorList.length ? (
        <>
          <StyledMailHeaderWrapper>
            <StyledMailHeader>
              <StyledMailToContainer>
                <Typography text="To：" />
                {filteredMonitorList.map((monitor) => (
                  <>
                    {sortedMailList.find(
                      (mail) => mail.monitor_id === monitor.id
                    )?.send_status === "FAIL" && <StyledMailError />}
                    <Typography text={`${monitor.name}（${monitor.ans_id}）`} />
                    {filteredMonitorList[filteredMonitorList.length - 1].id !==
                      monitor.id && <Typography text="、" />}
                  </>
                ))}
              </StyledMailToContainer>
              <Typography text={`件名：${sortedMailList[0].heading}`} />
            </StyledMailHeader>
          </StyledMailHeaderWrapper>
          <StyledMailContent>
            <StyledMailMessage>{sortedMailList[0].message}</StyledMailMessage>
          </StyledMailContent>
        </>
      ) : (
        <Typography text="通知を選択してください" size="large" />
      )}
    </StyledMailDetailCard>
  );
};
